/* import __COLOCATED_TEMPLATE__ from './add-new-external-source-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    model: {
      open?: boolean;
      appId: string;
      adminId: string;
      onClose: () => void;
    };
    options?: any;
  };
}

const AddNewExternalSourceSheet = templateOnlyComponent<Signature>();
export default AddNewExternalSourceSheet;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::KnowledgeHub::AddNewExternalSource::AddNewExternalSourceSheet': typeof AddNewExternalSourceSheet;
    'react/knowledge-hub/add-new-external-source/add-new-external-source-sheet': typeof AddNewExternalSourceSheet;
  }
}
